import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const useCloudTypes = () => {
  const ct = useSelector((s) => s.user.CloudTypes)

  const cloudTypesWP = useMemo(() => {
    return Object.keys(ct).filter((key) => ct[key]) // only truthy ones
  }, [ct])

  const cloudTypes = cloudTypesWP

  return { cloudTypes, cloudTypesWP }
}
